import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { debounce } from "lodash";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Input,
  Menu,
  Modal,
  Row,
  Switch,
  Table,
  Tooltip,
  message,
} from "antd";
import {
  DeleteOutlined,
  DingtalkOutlined,
  DollarOutlined,
  EditOutlined,
  EyeOutlined,
  FileSearchOutlined,
  FormOutlined,
  LockOutlined,
  MenuOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { SetRoute } from "../scripts/action";
import { CheckPermission, PriceFormat } from "../scripts/helpers";
import { Constants, Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import PaginationInfo from "../components/PaginationInfo";
import CreditForm from "../forms/Credit";
import PermissionForm from "../forms/Permission";
import UserForm from "../forms/User";
import ReportView from "../views/Report";
import UserView from "../views/User";

class UserAppPage extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      filter: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      selected: {},
    };

    this.formRef = React.createRef();
    this.creditFormRef = React.createRef();
    this.permissionFormRef = React.createRef();

    this.handleFilter = debounce(this.handleFilter, 1000);
  }

  fetch = (params = {}) => {
    const { filterLevel, filterSearch } = this.state;

    params.q = filterSearch;
    params.level = filterLevel;
    params.user_type = "installedApp";

    this.setState({ loading: true });

    API.user
      .list(params)
      .then((result) => {
        if (result.data) {
          this.setState({
            loading: false,
            data: result.data.data,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.data.current_page,
                pageSize: result.data.per_page,
                total: result.data.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showPermission = (user = {}) => {
    this.setState({ visiblePermission: true, selected: user });

    setTimeout(() => {
      this.permissionFormRef.current.handleDidMount(user);
    }, 0);
  };

  hidePermission = () => {
    this.setState({ visiblePermission: false });

    setTimeout(() => {
      this.permissionFormRef.current.handleWillUnmount();
    }, 0);
  };

  showForm = (user = {}) => {
    this.setState({ visibleForm: true, selected: user });

    setTimeout(() => {
      this.formRef.current.handleDidMount(user);
    }, 0);
  };

  hideForm = () => {
    this.setState({ visibleForm: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };

  showView = (user = {}) => {
    this.setState({ visibleView: true, selected: user });
  };

  hideView = () => {
    this.setState({ visibleView: false });
  };

  showCredit = (user = {}, decrease) => {
    this.setState({
      visibleCredit: true,
      decreaseCredit: decrease,
      selected: user,
    });
  };

  hideCredit = () => {
    this.setState({ visibleCredit: false });

    setTimeout(() => {
      this.creditFormRef.current.handleWillUnmount();
    }, 0);
  };

  showReport = (user = {}) => {
    this.setState({ visibleReport: true, selected: user });
  };

  hideReport = () => {
    this.setState({ visibleReport: false });
  };

  handleVoip = (record) => {
    this.props.history.push(`/phoneorders/${record.phone}`);
  };

  handleOrder = (record) => {
    this.props.history.push(`/orders/${record.phone}`);
  };

  handleFilter = (value, obj) => {
    const state = {};
    state[obj] = value;

    this.setState(state);

    setTimeout(() => {
      this.fetch({ page: 1 });
    }, 0);
  };

  handleCredit = (record) => {
    const action = this.state.decreaseCredit
      ? API.user.decreaseCredit
      : API.user.increaseCredit;

    this.setState({ submitting: true });

    record.id = this.state.selected.id;

    action(record)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.hideCredit();
        this.fetch({ page: this.state.pagination.current });
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleStatus = (record) => {
    Modal.confirm({
      title: record.status
        ? Resources.confirmUserDeactivate
        : Resources.confirmUserActivate,
      okText: Resources.yes,
      okType: record.status ? "danger" : "primary",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.user
          .statusUpdate(record)
          .then((result) => {
            message.success(result.message);
            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handlePermissions = (values) => {
    this.setState({ submitting: true });

    values.id = this.state.selected.id;

    API.user
      .permissionUpdate(values)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.hidePermission();
        this.fetch({ page: this.state.pagination.current });
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleVIP = (record) => {
    Modal.confirm({
      title: record.isVip ? Resources.confirmDelVIP : Resources.confirmAddVIP,
      okText: Resources.yes,
      okType: record.isVip ? "danger" : "primary",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.user
          .vipUpdate(record)
          .then((result) => {
            message.success(result.message);
            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleDelete = (record) => {
    Modal.confirm({
      title: Resources.confirmDeleteUser,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.user
          .delete(record)
          .then((result) => {
            message.success(result.message);

            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleSubmit = (values) => {
    const action = this.state.selected.id ? API.user.update : API.user.add;

    this.setState({ submitting: true });

    action(values, this.state.selected.id)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.hideForm();
        this.fetch({ page: this.state.pagination.current });
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleTableChange = (pagination) => {
    this.fetch({ page: pagination.current });
  };

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    this.fetch({ page: 1 });
  }

  render() {
    const {
      data,
      decreaseCredit,
      loading,
      pagination,
      selected,
      submitting,
      visibleCredit,
      visibleForm,
      visiblePermission,
      visibleReport,
      visibleView,
    } = this.state;
    const { permissions } = this.props;

    const columns = [
      {
        title: Resources.fullName,
        dataIndex: "name",
        render: (val, record) =>
          record.name ? `${record.name} ${record.family}` : record.family,
      },
      {
        title: Resources.personCode,
        dataIndex: "subscription_number",
      },
      {
        title: Resources.mobile,
        dataIndex: "phone",
        className: "col-center",
        width: "120px",
      },
      {
        title: Resources.permission,
        dataIndex: "level",
        width: "100px",
        className: "col-center",
        render: (val) => {
          switch (val) {
            case "admin":
              return Resources.admin;
            case "user":
              return Resources.user;
            case "postman":
              return Resources.postman;
            case "operator":
              return Resources.operator;
            case "accounting":
              return Resources.accounting;
            case "inventory":
              return Resources.warehousing;
            default:
              return "-";
          }
        },
      },
      {
        title: Resources.rank,
        dataIndex: "type",
        className: "col-center",
        width: "100px",
        render: (val) => val || "-",
      },
      {
        title: Resources.credit,
        dataIndex: "creditAccount",
        className: "col-center",
        render: (val) => PriceFormat(val || 0),
      },
      {
        title: Resources.status,
        dataIndex: "status",
        className: "col-center",
        width: "70px",
        render: (val, record) => (
          <Switch
            size="small"
            checked={!!parseInt(val)}
            onClick={() => this.handleStatus(record)}
            disabled={!permissions.action}
          />
        ),
      },
      {
        title: "VIP",
        dataIndex: "isVip",
        className: "col-center",
        width: "70px",
        render: (val, record) => (
          <Switch
            size="small"
            checked={!!parseInt(val)}
            onClick={() => this.handleVIP(record)}
            disabled={!permissions.action}
          />
        ),
      },
    ];

    const options = [
      { label: Resources.admin, value: "admin" },
      { label: Resources.user, value: "user" },
      { label: Resources.operator, value: "operator" },
    ];


    return (
      <Fragment>
        {console.log(data)}
        <Breadcrumb>
          <Breadcrumb.Item>{Resources.usersApp}</Breadcrumb.Item>
        </Breadcrumb>
        <div className="ant-content">
          <Row gutter={24}>
            <Col xs={24} md={6}>
              <Tooltip title={Resources.searchHintUser}>
                <Input
                    type="text"
                    prefix={<SearchOutlined />}
                    placeholder={Resources.search}
                    onChange={({ target: { value } }) =>
                        this.handleFilter(value, "filterSearch")
                    }
                    allowClear
                />
              </Tooltip>
            </Col>
          </Row>
        </div>
        <div className="ant-content">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            onChange={this.handleTableChange}
            pagination={pagination}
            size="small"
            rowKey="id"
            scroll={{ x: 900 }}
          />
          {!!pagination.total && (
            <PaginationInfo
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
            />
          )}
        </div>
        <CreditForm
          ref={this.creditFormRef}
          onCancel={this.hideCredit}
          onSubmit={this.handleCredit}
          submitting={submitting}
          visible={visibleCredit}
          decrease={decreaseCredit}
        />
        <PermissionForm
          ref={this.permissionFormRef}
          onCancel={this.hidePermission}
          onSubmit={this.handlePermissions}
          submitting={submitting}
          visible={visiblePermission}
        />
        <UserForm
          ref={this.formRef}
          onCancel={this.hideForm}
          onSubmit={this.handleSubmit}
          submitting={submitting}
          visible={visibleForm}
        />
        <ReportView
          data={selected}
          visible={visibleReport}
          onCancel={this.hideReport}
        />
        <UserView
          data={selected}
          visible={visibleView}
          onClose={this.hideView}
        />
      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        action: CheckPermission(state.app.user, Permissions.user_option),
        add: CheckPermission(state.app.user, Permissions.user_store),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(UserAppPage);
